













import { KaiwaDeck } from "@/models/KaiwaDeck";
import Vue, { PropType } from "vue";
import KaiwaDeckItem from "./KaiwaDeckItem.vue";

export default Vue.extend({
  name: "DeckList",
  components: {
    KaiwaDeckItem,
  },
  props: {
    decks: {
      type: Array as PropType<KaiwaDeck[]>,
      default: () => [],
    },
  },
  data: () => ({
    colNums: 2,
  }),
  computed: {
    rowNums() {
      return Math.ceil(this.decks.length / this.colNums);
    },
  },
  mounted() {
    this.onResize();
  },
  methods: {
    onResize() {
      this.colNums = window.innerWidth < 600 ? 1 : 2;
    },
    index(x: number, y: number) {
      return (y - 1) * this.colNums + x - 1;
    },
  },
});
